import {
  Link,
  useNavigate,
} from 'react-router-dom';
import { Button, Icon } from '@nazka/nazka.mapframe.components';
import { faChevronRight, faClose } from '@fortawesome/pro-regular-svg-icons';

import './panel-header.css';

function PanelHeader({
  map,
  municipalityId,
  municipalityName,
  sectorName,
  rootPath = '/afnemers',
  parentPath,
  parentName,
  currentName,
}) {
  const navigate = useNavigate();
  const hasSector = Boolean(sectorName);
  const hasParent = Boolean(parentPath && parentName);

  const handleClose = () => {
    navigate(rootPath);
    requestAnimationFrame(() => {
      map.resize();
      requestAnimationFrame(() => {
        map.stop();
        map.setMinZoom(0);
        map.fitBounds(map.getMaxBounds(), {
          padding: 48,
          duration: 0,
        });
      });
    });
  };

  return (
    <div className="panel-header">
      <nav className="panel-header__breadcrumb" aria-label="Breadcrumb">
        <ol className="panel-header__breadcrumb__list">
          <li
            className="panel-header__breadcrumb__item"
            aria-current={!hasSector && !hasParent ? 'page' : undefined}
          >
            {hasParent
              ? (
                  <Link
                    className="panel-header__breadcrumb__link"
                    to={parentPath}
                  >
                    {parentName}
                  </Link>
                )
              : (
                  hasSector
                    ? (
                        <Link
                          className="panel-header__breadcrumb__link"
                          to={`/afnemers/${encodeURIComponent(String(municipalityId))}`}
                        >
                          {municipalityName}
                        </Link>
                      )
                    : currentName || municipalityName
                )}
          </li>
          {hasSector && (
            <>
              <li
                className="panel-header__breadcrumb__separator"
                aria-hidden="true"
              >
                <Icon icon={faChevronRight} size="10px" />
              </li>
              <li
                className="panel-header__breadcrumb__item"
                aria-current="page"
              >
                {sectorName}
              </li>
            </>
          )}
          {hasParent && (
            <>
              <li
                className="panel-header__breadcrumb__separator"
                aria-hidden="true"
              >
                <Icon icon={faChevronRight} size="10px" />
              </li>
              <li
                className="panel-header__breadcrumb__item"
                aria-current="page"
              >
                {currentName}
              </li>
            </>
          )}
        </ol>
      </nav>
      <div className="panel-header__buttons">
        <Button
          icon={faClose}
          className="panel-header__buttons__button"
          onClick={handleClose}
          layout="ghost"
        />
      </div>
    </div>
  );
}

export default PanelHeader;
